import { useEffect, useState } from 'react';

import { useMediaQuery } from '@mui/material';
import { useRouter } from 'next/router';

import { getRecentSearchesAPI } from '@/api/getRecentSearches';
import NewNavbar from '@/components/BodyLayout/NewNavbar';
import Card from '@/components/IPFS/Card';
import arrowBlack from 'public/assets/arrow_black.svg';
import Logo from 'public/assets/logo-original2.svg';
import LogoSmall from 'public/assets/mainLogo.svg';
import search from 'public/assets/searchIcon.svg';
import searchWhite from 'public/assets/searchWhite.svg';

import { Spinner } from '../../components/Spinner/Spinner';
import FAQ from '../faq';

const Ipfs = () => {
  const [ipfsHash, setIpfsHash] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [recentSearches, setRecentSearches] = useState([]);
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const isMediaMax1232px = useMediaQuery('(max-width : 1232px)');
  const isMediaMax720px = useMediaQuery('(max-width : 720px)');
  const router = useRouter();
  const handleClick = async () => {
    setIsLoading(true);
    await router.push(`ipfs/${ipfsHash}`);
    setIsLoading(false);
  };

  const getRecentSearches = async () => {
    const res: any = await getRecentSearchesAPI();
    setRecentSearches(res.data.searches.slice(0, 8));
  };

  useEffect(() => {
    getRecentSearches();
  }, []);
  return (
    <div className={`flex flex-col bg-[#ffffff] h-full w-full items-center`}>
      <NewNavbar />
      <div
        className={`bg-yellow mt-[175px] rounded-full  ${
          isMediaMax1025px
            ? 'text-center flex flex-col justify-center items-center text-xs'
            : 'flex text-base'
        } p-3 px-6 border-black border font-semibold`}
      >
        <p className={`text-black mr-4 gap-2 items-center`}>
          This is just a sneak peek of the upcoming Fileverse Portal!{' '}
          {isMediaMax1025px && <br />} Don&apos;t miss our public beta, follow
          us on{' '}
          <a
            href="https://twitter.com/fileverse"
            target="_blank"
            className="underline"
            rel="noreferrer"
          >
            Twitter
          </a>
        </p>
        <span className="font-bold pl-3 flex items-center gap-2">
          <a href="https://fileverse.io/" target="_blank" rel="noreferrer">
            Learn more
          </a>
          <img src={arrowBlack.src} alt="" className="-rotate-90" />
        </span>
      </div>
      <div className="logo mt-20 w-[150px] h-[150px]">
        <img src={Logo.src} alt="" className="rounded-full" />
      </div>
      <div className="flex flex-col mt-6 items-center w-[70%] gap-8">
        <div
          className={`flex w-full ml-[10%] mr-[10%] ${
            isMediaMax720px && 'flex-col justify-center items-center gap-4'
          }`}
        >
          <div
            className={`input border border-gray-300 
            w-full p-2.5 dark:placeholder-gray-400 py-4 flex gap-6 ${
              isMediaMax720px ? 'rounded-lg' : 'rounded-tl-lg rounded-bl-lg'
            }`}
          >
            <img src={search.src} alt="" className="ml-2" />
            <input
              className="w-full text-xl"
              onChange={(event) => setIpfsHash(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  handleClick();
                }
              }}
              placeholder="Search any IPFS Hash here..."
            />
          </div>
          <button
            className={`bg-black text-white px-14 py-4 text-xl ${
              isMediaMax720px ? 'rounded-lg' : 'rounded-tr-lg rounded-br-lg'
            }`}
            onClick={handleClick}
          >
            {isLoading ? <Spinner /> : <img src={searchWhite.src} alt="" />}
          </button>
        </div>
        <div className="info w-[90%] mt-8">
          <ul
            id="ipfs-list"
            className={`flex gap-2 ${
              isMediaMax1232px && 'flex-col justify-center items-center'
            } list-disc marker:text-2xl marker:text-yellow justify-between text-lg font-semibold`}
          >
            <li>Search any public IPFS Hash</li>
            <li>Search by content, not by IP</li>
            <li>Search & view any type of file</li>
          </ul>
        </div>
      </div>
      <div
        id="custom-bg"
        className="flex flex-col px-4 gap-1 items-center w-full relative mt-28"
      >
        <p className="text-2xl font-bold text-center">Recent Searches</p>
        <div className="z-10 recent-searches pt-5 w-[85%]">
          <div className="cards flex flex-wrap justify-center items-start gap-10">
            {recentSearches.map((item) => (
              <Card
                key={Math.random()}
                previewUrl={item.previewUrl}
                name={item.name}
                ipfsHash={item.ipfsHash}
                timestamp={item.timestamp}
              />
            ))}
          </div>
        </div>
        <div className="z-10 recent-searches pt-10 flex flex-col gap-4 justify-center items-center">
          <FAQ />
        </div>
        <div className="bg w-[100%] h-[92%] mt-28 right-0 bottom-0  bg-yellow rounded-t-[35%] absolute -z-10"></div>
      </div>
      <div className="justify-center py-2 px-4 flex items-center font-normal text-sm	text-[#777777]">
        <img src={LogoSmall.src} className="w-8 h-8" alt="" />
        <div className="text-xs text-[#777777] pl-2">
          Attention! Fileverse Solo is a proof of concept on how IPFS can work
          for file sharing. Solo is in alpha. Expect upgrades in 2026 💛
        </div>
      </div>
    </div>
  );
};

export default Ipfs;
